import { useState, useEffect } from 'react';

export interface BreakPoints {
  medium: 764;
}

function useScreenWidth({ width }: { width: number }) {
  const [matched, setMatched] = useState(false);
  useEffect(() => {
    function matchMedia() {
      if (window.matchMedia(`(min-width:${width}px)`).matches) {
        setMatched(true);
      } else {
        setMatched(false);
      }
    }

    matchMedia();

    //debounce
    let doit: any;
    function handleResize() {
      clearTimeout(doit);
      doit = setTimeout(() => {
        matchMedia();
      }, 0);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return matched;
}

export { useScreenWidth };
